<template src="./location.html"></template>
<script>  
  import Multiselect from "vue-multiselect";
  import Axios from "axios";
  import $ from "jquery";  

  export default {
    components: {      
      Multiselect,
    },
    filters: {
      date: function (data) {
        if (data == "" || data == null) {
          return "--";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        return reqdString;
      },      
    },
    data() {
      return {
        basic: {
          currentPage: 1,
          totalPages: 0,
        },        
        ShowLoader: false,
        SearchForm: {
          Name: "",
        },
        LocationList: [],
        ShowLocationAddModel: "",
        SubmitLocation: {},
        ShowLocationAdd: false,
        ShowLocationEdit: false,
        ShowLocationDelete: false,
      };
    },
    mounted() {
      /*var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions.Assets.Location || !AccountPermissions.Assets.Location.enable)
      ) {
        this.$router.push("/");
      }

      if (
        AccountPermissions &&
        AccountPermissions.Assets.Location &&
        AccountPermissions.Assets.Location.enable
      ) {
        if (AccountPermissions.Assets.Location.add) {
          this.ShowLocationAdd = true;
        }
        if (AccountPermissions.Assets.Location.edit) {
          this.ShowLocationEdit = true;
        }
        if (AccountPermissions.Assets.Location.delete) {
          this.ShowLocationDelete = true;
        }
      }
      if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowLocationAdd = true;
        this.ShowLocationEdit = true;
        this.ShowLocationDelete = true;
      }*/
      this.ShowLocationAdd = true;
      this.ShowLocationEdit = true;
      this.ShowLocationDelete = true;
      document.title = pbx_SiteTitle + " - Assets Location";
      this.GetLocationList();
    },

    methods: {
      initSubmitLocationObject() {
        this.SubmitLocation = {
          	id: 0,
          	name: "",
          	address: "",
        };
      },
      GetLocationList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        if (type == "search") {
          obj.name = this.SearchForm.Name;
        }
        this.ShowLoader = true;
        Axios.post(Endpoints.Assets.Location.List, obj).then((Response) => {
          	this.ShowLoader = false;
          	if (Response.data.success) {
            	this.LocationList = Response.data.LocationList;
          	}
        });
      },
      AddNewLocation() {
        this.ShowLocationAddModel = true;
    	this.initSubmitLocationObject();
      },
      EditLocation(location) {
        this.ShowLocationAddModel = true;
        this.SubmitLocation = {};
        this.SubmitLocation.id = location.id;
        this.SubmitLocation.name = location.name;
        this.SubmitLocation.address = location.address;
      },
      AddLocationSubmit() {
        var error = false;
        var errorStr = "";
        if (!this.SubmitLocation.name) {
          error = true;
          errorStr += "<li>Please Enter Location Name</li>";
        }
        if (!this.SubmitLocation.address) {
          error = true;
          errorStr += "<li>Please Enter Location Address</li>";
        }
        if (error == true) {
          this.$swal("Following Error Found!", errorStr, "error").then(() => {});
        } else {
          this.$swal({
            title: "Adding Location...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          var postUrl = Endpoints.Assets.Location.Create;
          if (this.SubmitLocation && this.SubmitLocation.id > 0) {
            postUrl = Endpoints.Assets.Location.Update;
          }
          Axios.post(postUrl, {
            token: localStorage.getItem("token"),
            SubmitLocation: this.SubmitLocation,
          }).then((Response) => {
            if (Response.data.success == true) {
              	this.ShowLocationAddModel = false;
              	this.GetLocationList();
              	this.initSubmitLocationObject();
              	this.$swal("Location Added Successfully", "", "success").then(() => {});
            } else {
              	this.$swal(Response.data.message, "", "error").then(() => {});
            }
          });
        }
      },
      DeleteLocation(location) {
        this.$swal
          .fire({
            title: "Are you sure You want to Delete this Location?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete it!",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$swal({
                title: "Deleting Location...",
                text: "Please wait...",
                imageUrl: require("@/assets/images/LoadingTwo.gif"),
                showConfirmButton: false,
                allowOutsideClick: false,
              });

              Axios.post(Endpoints.Assets.Location.Delete, {
                token: localStorage.getItem("token"),
                id: location.id,
              }).then((Response) => {
                if (Response.data.success == true) {
                  this.GetLocationList();
                  this.$swal("Location Deleted Successfully","","success").then(() => {});
                } else {
                  this.$swal(Response.data.message, "", "error").then(() => {});
                }
              });
            }
          });
      },
    },
  };
</script>
